<template>
  <div class="order-container bgc-gradient">
    <Header title="订单"></Header>
    <Scroll ref="wrapper" :listenScroll="false" :pullUpLoad="pullUpLoadObj"
            @pullingUp="onPullUpLoad" :pullDownRefresh="pullDownRefreshObj" @pullingDown="onPullDownRefresh">
      <Search :keyName="keyName" @onSearch="onSearch" @onCancel="onCancel" style="background: transparent;"></Search>
      <div class="tabs-container">
        <van-tabs v-model="orderStatus" @on-click="TabsGetList" sticky>
          <van-tab v-for="tab in tabList" :key="tab.key" :name="tab.key" :title="tab.name" />
            <OrderCard v-for="(item, index) in orderList" :key="index" :order="item" @cancelOrder="cancelOrder"></OrderCard>
            <van-empty v-if="dataEmpty" class="custom-empty" description="暂无数据"></van-empty>
        </van-tabs>
      </div>
    </Scroll>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Search from "./components/Search.vue";
import OrderCard from "./components/OrderCard";
// import FilterList from "./components/FilterList";
import orderApi from "@/request/orderApi";
// import commonApi from "@/request/commonApi";
import Scroll from "@/components/Scroll";
export default {
  name: "Order",
  components: {
    Header,
    Search,
    OrderCard,
    // FilterList,
    Scroll,
  },
  data() {
    return {
      keyName: "输入卖家名称",
      orderStatus: "1",
      orderList: [],
      sellers: [],
      tabList: [
        {
          key: "",
          name: "全部",
        },
        {
          key: "0_1,0_2,0_3",
          name: "待确认",
        },

        {
          key: "1,1_1,2_3",
          name: "待审核",
        },
        {
          key: "2,2_2",
          name: "审核中",
        },
        {
          key: "3",
          name: "待发货",
        },
        {
          key: "4",
          name: "发货中",
        },
        {
          key: "9",
          name: "已完成",
        },
        {
          key: "-1",
          name: "已取消",
        }
      ],
      hasNextPage: true,
      scrollParams: {
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "",
        pullUpLoadNoMoreTxt: "",
      },
      searchForm: {
        orderNoLk: "",
        commodityNameLk: "",
        sellerEnterpriseNameLk: "",
        tradeType: "",
        deliveryMode: "",
        status: "",
        proxy: "",
        createDateFrom: "",
        createDateTo: "",
      },
      formPage: {
        pageSize: 10,
        currentPage: 1,
        totalRows: 0,
     },
    };
  },
  computed: {
    pullUpLoadObj() {
      return this.scrollParams.pullUpLoad
        ? {
            threshold: parseInt(this.scrollParams.pullUpLoadThreshold),
            txt: {
              more: this.scrollParams.pullUpLoadMoreTxt,
              noMore: this.scrollParams.pullUpLoadNoMoreTxt,
            },
          }
        : false;
    },
    pullDownRefreshObj() {
      return this.scrollParams.pullDownRefresh
        ? {
            threshold: parseInt(this.scrollParams.pullDownRefreshThreshold),
            stop: parseInt(this.scrollParams.pullDownRefreshStop),
          }
        : false;
    },
    valueSet() {
      return this.$store.state.codeValue.valueSet;
    },
    statusType() {
      return this.$store.state.valueSet.NG_ORDER_STATUS;
    },
    orderType() {
      return this.$store.state.valueSet.NG_ORDER_TYPE;
    },
    dataEmpty() {
      return this.orderList.length == 0 && !this.loading;
    },
  },
  watch: {
    //TAB切换
    orderStatus(val) {
      this.searchForm.status = val;
      this.formPage.currentPage = 1;
      this.formPage.totalRows = 0;
      this.getOrderList();
    },
  },
  created() {
    this.orderStatus = this.$route.query.active || 0
    // this.getBrandList();
  },
  methods: {
    // onFilter() {
    //   this.filterFlag = !this.filterFlag;
    // },
    onSearch (val) {
      this.searchForm.sellerEnterpriseNameLk = val
      this.getOrderList();
    },
    onCancel(){
      this.searchForm.sellerEnterpriseNameLk = "";
      this.getOrderList();
    },
    //上拉加载
    onPullUpLoad() {
      if (!this.hasNextPage) {
        this.$refs.wrapper.forceUpdate(false);
        return false;
      } else {
        setTimeout(() => {
          this.formPage.currentPage++;
          this.getOrderList();
        }, 1000);
      }
    },
    //下拉刷新
    onPullDownRefresh() {
      setTimeout(() => {
        this.formPage.currentPage = 1;
        this.orderList = [];
        this.getOrderList();
      }, 1000);
    },
    refreshData(queryList) {
      this.onFilter();
      this.searchForm = this.$options.data().searchForm;
      for (let i = 0; i < queryList.length; i++) {
        let item = queryList[i];
        if (item.key == "commodityName") {
          let productTypes = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (productTypes.length > 0) {
            this.searchForm.productLine = productTypes[0].key;
          }
          continue;
        }
        if (item.key == "sellers") {
          let sellers = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (sellers.length > 0) {
            this.searchForm.sellerEnterpriseCode = sellers[0].key;
          }
          continue;
        }
        if (item.key == "orderType") {
          let types = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (types.length > 0) {
            this.searchForm.tradeType = types[0].key;
          }
          continue;
        }
        if (item.key == "orderStatus") {
          let status = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (status.length > 0) {
            this.Pagedata.status = status[0].key;
          }
          continue;
        }
      }
      this.orderList = [];
      this.formPage.currentPage = 1;
      this.getOrderList();
    },
    TabsGetList(val) {
       this.form.status = val;
       this.getOrderList();
    },
    getOrderList() {
      let params = Object.assign({}, this.searchForm, this.formPage);
      delete params.totalRows;
      this.orderList = [];
      orderApi.getOrderList(params).then((res) => {
        if (res.returnCode == "0") {
          let tempList = res.result.dataList;
          for (let i in tempList) {
            tempList[i].createTime = tempList[i].createTime
              ? this.$utils.formatDateTime(tempList[i].createTime)
              : "--";
            tempList[i].amount = this.$utils.amount(tempList[i].amount);
            tempList[i].deliveryDateEnd = this.$utils.formatDateTime(
              tempList[i].deliveryDateEnd
            );
          }
          this.orderList = this.orderList.concat(tempList);
          // this.Pagedata.currentPage++;
          this.hasNextPage = res.result.hasNextPage;
          this.$refs.wrapper.forceUpdate(false);
          // if (this.hasNextPage) {
          //   this.$refs.wrapper.forceUpdate(true);
          // } else {
          //   this.$refs.wrapper.forceUpdate(false);
          // }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    cancelOrder() {
       this.getOrderList();
    },

  },
};
</script>
<style lang="stylus" scoped>
.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;

.tabs-container {
  flex: 1;
  display: flex;
  overflow: hidden;

/deep/ .van-sticky {
  margin: 0 0.32rem;
}
/deep/ .van-tabs .van-tabs__wrap .van-tab {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #666666;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
/deep/ .van-tab--active {
  color: #333333 !important;
  font-weight: 800 !important;
}
/deep/ .van-tabs__nav {
  background-color: transparent;
}



/deep/ .van-tabs__wrap {
  height: 60px;
}
}
}

/deep/ .van-tabs__line {
  width: 24px;
  height: 4px;
  background: #E0000C;
  border-radius: 3px 3px 3px 3px;
}
</style>
